import { DateRangeComponent } from '@app/formly/types/date-range/date-range.component';
import { DateV3Component } from '@app/formly/types/v3/date-v3/date-v3.component';
import { AirportFieldComponent } from './airport-field/airport-field.component';
import { MultiSelectFieldComponent } from './multi-select-field/multi-select-field.component';
import { SingleSelectFieldComponent } from './single-select-field/single-select-field.component';
import { FreeTextFieldComponent } from './free-text-field/free-text-field.component';
import { MonthPeriodFieldComponent } from './month-period-field/month-period-field.component';

export const tableFiltersTypes = [
  { name: 'SINGLE_SELECT', component: SingleSelectFieldComponent },
  { name: 'MULTI_SELECT', component: MultiSelectFieldComponent },
  { name: 'DATE_RANGE', component: DateRangeComponent },
  { name: 'FREE_TEXT', component: FreeTextFieldComponent },
  { name: 'AIRPORT', component: AirportFieldComponent },
  { name: 'MONTH_PERIOD', component: MonthPeriodFieldComponent },
  // A single day, value 'YYYY-MM-DD' (e.g. the Sales Organization page's As of).
  { name: 'DATE', component: DateV3Component },
];
